import React from 'react'

import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FieldGroup } from './FieldGroup'

export const SignupForm = ({ onSubmit, onChange, validateForm, username, children }) => (
  <div className="container">
    <div className="row AuthContainer vertical">
      <div className="AuthContainerForm">
        <div className="col-md-6">
          <h1>Sign Up</h1>
          <p>To <strong>create a new </strong>account on Owner&apos;s Edge</p>
          {children}
          <form onSubmit={onSubmit} className="col">
            <FieldGroup id="username" label="Email Address" value={username} onChange={onChange} autoFocus className="field-group_input" />
            <Button id="signup-button" className="btn btn-default" type="submit" disabled={!validateForm()}>
              Submit
            </Button>
            <Link id="login-button" to="/login" className="btn btn-link"> Have you used Owner’s Edge before? Login here.</Link>
          </form>

        </div>
      </div>
    </div>
  </div >
)
